import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    // Listen for the custom event
    document.addEventListener("updateCompanyAddresses", this.updateSelect);
  }

  disconnect() {
    // Clean up the event listener
    document.removeEventListener("updateCompanyAddresses", this.updateSelect);
  }

  fetchAddresses(event) {
    if (event.target.id === 'hidden_company_id_MTG') {
      const companyId = event.target.value;

      if (companyId) {
        fetch(`/companies/${companyId}/company_addresses.json`)
          .then(response => {
            if (!response.ok) throw new Error('Bad response');
            return response.json();
          })
          .then(data => {
            let options = data.addresses.map((address) => ({
              id: address.id,
              name: address.name
            }));

            options.unshift({ id: 0, name: 'All' });

            const updateEvent = new CustomEvent('updateCompanyAddresses', {
              detail: {
                addresses: options,
                targetSelectId: 'hidden_company_address_id_MTG'
              }
            });
            document.dispatchEvent(updateEvent);
          })
          .catch(error => {
            console.error("Error fetching company addresses:", error);
          });
      } else {
        const clearEvent = new CustomEvent('updateCompanyAddresses', {
          detail: {
            addresses: [],
            targetSelectId: 'hidden_company_address_id_MTG'
          }
        });
        document.dispatchEvent(clearEvent);
      }
    }
  }

  updateSelect = (event) => {
    const { addresses, targetSelectId } = event.detail;
    const select = document.getElementById(targetSelectId);
    if (select) {
      // Clear current options
      select.innerHTML = "";

      // Add new options
      addresses.forEach(address => {
        const option = document.createElement("option");
        option.value = address.id;
        option.text = address.name;
        select.appendChild(option);
      });
    }
  }
}
